module.exports = __webpack_public_path__ + "img/logo.88f7c00c.png";